import React, { useState } from 'react';
import '../css/Login.css';

import key from '../images/key.png';
import lock from '../images/lock.png';
import CustomAlert from './CustomeAlert';


function Login({ onLogin }) {
  const [passVisible, setPassVisible] = useState(false);
  const [uname, setUname] = useState('');
  const [password, setPassword] = useState('');
  const [alertData, setAlertData] = useState({ show: false, message: '' });

  const validation = (e) => {
    e.preventDefault();

    if (uname === 'admin' && password === 'pass@123') {
      setAlertData({ show: true, message: 'Login Successful' });
      onLogin(); // Trigger the onLogin function passed as a prop
    } else {
      setAlertData({ show: true, message: 'Login Failed' });
    }
  };

  const closeAlert = () => {
    setAlertData({ show: false, message: '' }); // Close the alert
  };

  return (
    <div>
      {/* Show CustomAlert when alertData.show is true */}
      <CustomAlert show={alertData.show} message={alertData.message} onClose={closeAlert} />
      
      <div className="container d-flex align-items-center justify-content-center vh-100">
  <div className=" p-4 shadow rounded " style={{maxWidth:"400px",background:"#8DCBE6"}} >
    <form onSubmit={validation}>
      <div className="text-center mb-4">
        <h2 style={{ color: "black" }}>Login</h2>
      </div>
      <div className="mb-3">
        <label htmlFor="username" className="form-label">User Name</label>
        <input
          type="text"
          className="form-control"
          id="username"
          value={uname}
          onChange={(e) => setUname(e.target.value)}
          required
        />
      </div>
      <div className="mb-3 position-relative">
        <label htmlFor="password" className="form-label">Password</label>
        <div className="input-group">
          <input
            type={passVisible ? 'text' : 'password'}
            className="form-control"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <button
            className="btn btn-outline-secondary"
            type="button"
            onClick={() => setPassVisible(!passVisible)}
          >
            <img
              src={passVisible ? key : lock}
              alt={passVisible ? "Hide password" : "Show password"}
              style={{ width: "20px", height: "20px" }}
            />
          </button>
        </div>
      </div>
      <div className="text-center">
        <button type="submit" className="btn btn-primary w-50">Submit</button>
      </div>
    </form>
  </div>
</div>
</div>
  );
}

export default Login;
